import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { CreditCard, Gift, Smartphone, ArrowRight, Check } from 'lucide-react';
import { pillars } from '../../data/mock';

const iconMap = {
  CreditCard,
  Gift,
  Smartphone
};

const Pillars = () => {
  return (
    <section id="solution" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#6B2C91] font-semibold text-sm uppercase tracking-wider">
            Notre Écosystème
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-gray-900">
            Une Carte, Mille Possibilités
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            KIPAY n'est pas une énième carte bancaire. C'est LA solution de paiement 
            intelligente qui unifie toute votre expérience EKIP.
          </p>
        </div>

        {/* Pillars Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => {
            const Icon = iconMap[pillar.icon];
            return (
              <Card
                key={pillar.id}
                className="group relative p-8 border-0 shadow-lg hover:shadow-2xl transition-all duration-500 bg-white overflow-hidden"
              >
                {/* Hover gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#6B2C91]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-[#6B2C91]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-[#6B2C91]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-[#6B2C91] font-medium mb-4">
                    {pillar.subtitle}
                  </p>
                  <p className="text-gray-600 mb-6">
                    {pillar.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-3 mb-6">
                    {pillar.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-700">
                        <Check className="w-4 h-4 text-[#00C853] mr-2 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <Button
                    variant="ghost"
                    className="text-[#6B2C91] hover:bg-[#6B2C91]/10 p-0 h-auto font-semibold group/btn"
                  >
                    Découvrir
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#6B2C91] to-[#FFD700] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              </Card>
            );
          })}
        </div>

        {/* Bottom Promise */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-[#6B2C91]/5 to-[#FFD700]/5 rounded-2xl">
            <div className="w-12 h-12 bg-[#FFD700] rounded-full flex items-center justify-center">
              <span className="text-2xl font-bold text-gray-900">+</span>
            </div>
            <p className="text-lg font-medium text-gray-900">
              <span className="text-[#6B2C91]">Notre promesse :</span> Plus vous utilisez KIPAY dans l'écosystème EKIP, plus vous gagnez.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pillars;
